class FacetDrawer extends MainDrawer {
  constructor() {
    super();

    this.trigger = this.querySelector('.drawer__trigger');
    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.loadAssets());
    }
  }

  loadAssets() {
    if (!document.getElementById('FACETSCSS') && !document.getElementById('FACETSJS')) {
      this.classList.add('loading');
    }

    loadCss('facets')
      .then(() => {
        setTimeout(() => {
          this.classList.remove('loading');
        }, 300);
      })
      .catch((error) => {
        console.error(error);
      });
    loadScript('facets').catch((error) => {
      console.error(error);
    });
    this.openDrawer();
  }
}
customElements.define('facet-drawer', FacetDrawer);

const grid = document.querySelector('#product-grid');

const hideExtraProducts = () => {
  const promoBanner = document.querySelector('li.promo-banner');
  const items = grid.querySelectorAll('li.grid__item');
  items.forEach(item => item.style.display = '');

  const loadMoreBtn = document.querySelector('#loadMore');
  if (loadMoreBtn && loadMoreBtn.hasAttribute('hidden')) {
    return;
  }

  if (promoBanner) {
    const index = items.length - 1;
    if (index >= 0) {
      items[index].style.display = 'none';
    }
  }
};

hideExtraProducts();

const observer = new MutationObserver(hideExtraProducts);
observer.observe(grid, { childList: true, subtree: false });